import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import en from './en';
import ar from './ar';

const TRANSLATIONS = { en, ar };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('fleet_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('fleet_lang', lang);
    document.documentElement.dir  = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  /* `t` and the context value are both stable across renders. As plain
     literals they were new objects every time, so every component that lists
     `t` in a useMemo or useCallback dependency array — the data grid's whole
     column model among them — rebuilt on every keystroke anywhere in the
     app. Only a language change should invalidate them. */
  const t = useCallback(
    (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en?.[key] ?? key,
    [lang],
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
